import { initialize } from './helpers/init'
import loadBundles from './helpers/loadBundles'
import initPageTransitions from './components/initTransitions'

/* Optional */
import svg4everybody from 'svg4everybody'
import fitvids from 'fitvids'
import 'focus-visible'

/* Import components as needed */
import MenuDropdown from './components/menu/menuDropdown'
import MenuSimple from './components/menu/menuSimple'
//import CookieBanner from './components/cookieBanner'
import Filter from './components/filter'
import InstagramShare from './components/instagramShare'
import ThemeSwitcher from './components/themeSwitcher'
import SearchSidebar from './components/searchSidebar'
import Card from './components/card'
import onLoad from './components/onLoad'
import IndicateScroll from './components/indicateScroll.js'

document.body.classList.remove('no-js')

// document.body.classList.add('low-energy')

svg4everybody({
  polyfill: true,
})

fitvids()

document.onreadystatechange = () => {
  if (document.readyState === 'complete') {
    document.body.classList.remove('is-loading')
    document.body.classList.add('is-loaded-complete')
  }
}

/* Initialize components as needed */
initialize('menu', MenuDropdown)
initialize('menu-simple', MenuSimple)
//initialize('cookie-banner', CookieBanner)
initialize('card', Card)
initialize('filter', Filter)
initialize('instagram-share', InstagramShare)
initialize('theme-switcher', ThemeSwitcher)
initialize('search-sidebar', SearchSidebar)
initialize('indicate-scroll', IndicateScroll)

onLoad()
initPageTransitions()

/*
  ** Conditionally load bundles **
  ---
  Only do this if you have large components or dependencies that you don't want to load on every page (e.g. a Vue application). Otherwise import and initialise them in the normal way, above.
*/
const bundles = [
  {
    selector: 'accordion',
    fileName: 'accordion',
  },
  {
    selector: 'tabs',
    fileName: 'tabs',
  },
  {
    selector: 'accordion-tabs',
    fileName: 'accordionTabs',
  },
  {
    selector: 'parallax',
    fileName: 'parallax',
  },
  {
    selector: 'hero-video',
    fileName: 'heroVideo',
  },
  {
    selector: 'hero-carousel',
    fileName: 'heroCarousel',
  },
  {
    selector: 'gallery',
    fileName: 'customGallery',
  },
]
loadBundles(bundles)

/* Only load Vue if #app element present on the page */
const importVue = () => {
  if (!document.querySelector('.as-sdg')) return

  import('./vue/app.js').then((object) => {
    const vueApp = object.default
    vueApp()
  })
}

importVue()
